import { useState, useEffect } from 'react';
import firebase from 'firebase/app';

/**
 * Fetches team member roles for (teamId, clientId) pairs.
 * Returns a map of "teamId-clientId" -> roles array (e.g. ['admin'], ['member']).
 */
export function useClaimerRoles(pairs) {
    const [rolesMap, setRolesMap] = useState({});

    useEffect(() => {
        const filtered = (pairs || []).filter((p) => p.teamId && p.clientId);
        const seen = new Set();
        const unique = filtered.filter((p) => {
            const key = `${p.teamId}-${p.clientId}`;
            if (seen.has(key)) return false;
            seen.add(key);
            return true;
        });
        if (unique.length === 0) {
            setRolesMap({});
            return;
        }

        const db = firebase.firestore();
        const fetches = unique.map(({ teamId, clientId }) =>
            db.collection('teams').doc(teamId).collection('members').doc(clientId).get()
        );

        Promise.all(fetches).then((snapshots) => {
            const map = {};
            snapshots.forEach((snap, i) => {
                const key = `${unique[i].teamId}-${unique[i].clientId}`;
                const data = snap.exists ? snap.data() : null;
                map[key] = Array.isArray(data?.roles) ? data.roles : [];
            });
            setRolesMap(map);
        }).catch((err) => {
            console.error('useClaimerRoles error:', err);
            setRolesMap({});
        });
    }, [(pairs || []).map((p) => `${p.teamId}-${p.clientId}`).join(',')]);

    return rolesMap;
}
